import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitonarmadaparokramacab() {



  const cardData = {
    keyword: " Mumbai to Narmada Parikrama Cab Booking",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Narmada Parikrama cab booking services, ensuring a safe, smooth, and spiritually enriching journey for pilgrims, families, and group travelers. The Narmada Parikrama is one of the most sacred Hindu pilgrimages, involving a devotional journey along the banks of the holy Narmada River, passing through important spiritual towns, temples, and natural landscapes across Madhya Pradesh and Gujarat. Our professional drivers and well-maintained vehicles ensure a stress-free long-distance travel experience throughout this divine yatra. The Mumbai to Narmada Parikrama route can vary depending on the itinerary, typically covering 1000+ km in multiple legs over several days as devotees visit key parikrama points. We offer flexible booking options including one-way drops to starting points, multi-day round trips, and customized pilgrimage packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for individuals, families, and large spiritual groups. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Narmada Parikrama travel.",

"topPlaces": [
  {
    "title": "Omkareshwar Jyotirlinga",
    "description": "Omkareshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva, located on an island shaped like the sacred Hindu symbol ‘Om’ in the Narmada River. It is a major spiritual center for Narmada Parikrama pilgrims, offering divine darshan, riverbank rituals, and peaceful ghats surrounded by hills and flowing waters."
  },
  {
    "title": "Maheshwar Ghats",
    "description": "Maheshwar is a historic temple town situated on the banks of the Narmada River, famous for its beautifully built ghats, fort, and handloom sarees. The serene riverfront is a key stop in Narmada Parikrama, where pilgrims perform rituals, take holy dips, and experience the calm spiritual atmosphere of ancient Madhya Pradesh."
  },
  {
    "title": "Mandla River Region",
    "description": "Mandla is one of the important regions along the upper Narmada stretch, surrounded by forests, tribal culture, and natural beauty. It is deeply connected with the origin and early flow of the Narmada River, making it a significant spiritual and ecological stop during the parikrama journey."
  },
  {
    "title": "Jabalpur Narmada Ghat",
    "description": "Jabalpur is a major city along the Narmada River known for its scenic ghats and the famous Bhedaghat marble rocks nearby. Pilgrims experience river rituals, boating through marble cliffs, and divine views of the flowing Narmada, making it one of the most visually stunning segments of the parikrama route."
  },
  {
    "title": "Bhedaghat Marble Rocks",
    "description": "Bhedaghat is famous for its towering white marble rock formations along the Narmada River, creating a breathtaking canyon-like landscape. The boat ride between these marble cliffs is a unique spiritual and natural experience, often considered one of the most beautiful sights along the Narmada Parikrama route."
  },
  {
    "title": "Narmada Udgam (Amarkantak)",
    "description": "Amarkantak is the sacred origin point of the Narmada River, located in the Maikal Hills of Madhya Pradesh. It is one of the holiest pilgrimage sites where devotees begin or complete spiritual journeys, surrounded by forests, temples, and a peaceful high-altitude environment."
  },
  {
    "title": "Hoshangabad (Narmadapuram) Ghats",
    "description": "Hoshangabad, now known as Narmadapuram, is an important river city situated on the banks of the Narmada. Its ghats are widely used by pilgrims for rituals, meditation, and rest during the long parikrama journey, offering calm waters and spiritual surroundings."
  },
  {
    "title": "Rajpipla Spiritual Route (Gujarat Side)",
    "description": "Rajpipla in Gujarat is an important part of the Narmada Parikrama route on the southern bank return journey. It features temples, forest landscapes, and proximity to the Statue of Unity region, making it a significant cultural and spiritual transition point."
  },
  {
    "title": "Garudeshwar Dham",
    "description": "Garudeshwar Dham is a sacred pilgrimage site near Kevadia dedicated to Lord Dattatreya, located close to the Narmada River. It is frequently visited by Parikrama pilgrims for spiritual blessings and is known for its peaceful riverfront and devotional atmosphere."
  },
  {
    "title": "Bharuch Narmada Sangam Region",
    "description": "Bharuch is one of the oldest port cities in India situated near the mouth of the Narmada River as it approaches the Arabian Sea. It holds historical and spiritual importance in the Narmada Parikrama, marking the river’s journey towards the ocean and symbolizing completion of a sacred cycle."
  }
],






services: [
  {
    name: "Mumbai to Narmada Parikrama Cab",
    description: "Mumbai to Narmada Parikrama cab service provides comfortable and reliable transportation for spiritual and pilgrimage journeys. It is ideal for devotees traveling for Narmada Parikrama yatra. Professional drivers ensure a safe and smooth journey. It offers a peaceful travel experience with flexible stops."
  },
  {
    name: "Narmada Parikrama Cab from Mumbai",
    description: "Narmada Parikrama cab from Mumbai offers dedicated travel services for pilgrims starting their sacred journey from Mumbai. It provides well-maintained vehicles and experienced drivers. Suitable for long religious trips with family or groups. It ensures comfort and devotion-focused travel."
  },
  {
    name: "Mumbai to Narmada Yatra Taxi",
    description: "Mumbai to Narmada Yatra taxi service provides reliable transportation for spiritual tours and pilgrimage visits. It ensures a safe, comfortable, and well-planned journey. Ideal for devotees traveling to Narmada river locations. It guarantees smooth travel experience."
  },
  {
    name: "Mumbai to Narmada Parikrama Cab Service",
    description: "Mumbai to Narmada Parikrama cab service offers customized pilgrimage travel packages for devotees. It includes flexible routes and stop options during the journey. Professional chauffeurs ensure safety and comfort. It is ideal for religious tours."
  },
  {
    name: "Cab from Mumbai for Narmada Parikrama",
    description: "Cab from Mumbai for Narmada Parikrama provides door-to-door pickup and drop services for pilgrims. It ensures hassle-free long-distance travel with reliable vehicles. Suitable for family and group travel. It guarantees a smooth spiritual journey."
  },
  {
    name: "Taxi from Mumbai for Narmada Yatra",
    description: "Taxi from Mumbai for Narmada Yatra offers comfortable and safe travel solutions for devotees visiting holy destinations along the Narmada route. It provides experienced drivers familiar with pilgrimage routes. It ensures peaceful and secure travel."
  },
  {
    name: "Mumbai to Narmada Parikrama Cab Booking",
    description: "Mumbai to Narmada Parikrama cab booking allows easy reservation of vehicles for pilgrimage travel. It offers instant confirmation and flexible cab options. Ideal for planned spiritual journeys. It ensures a smooth booking experience."
  },
  {
    name: "Mumbai to Narmada Parikrama Taxi Booking Online",
    description: "Mumbai to Narmada Parikrama taxi booking online enables quick and convenient booking through digital platforms. It offers transparent pricing and reliable service. Suitable for urgent and planned pilgrimage travel. It ensures seamless booking experience."
  },
  {
    name: "Mumbai to Narmada Parikrama Cab Price",
    description: "Mumbai to Narmada Parikrama cab price depends on distance, vehicle type, and duration of the pilgrimage tour. It offers flexible pricing options for different budgets. Transparent rates ensure no hidden charges. It helps in travel planning."
  },
  {
    name: "Mumbai to Narmada Parikrama Taxi Fare",
    description: "Mumbai to Narmada Parikrama taxi fare is calculated based on route length and cab category. It provides affordable and clear pricing for pilgrims. Suitable for long spiritual journeys. It ensures transparency and cost efficiency."
  },
  {
    name: "Mumbai to Narmada Parikrama One Way Cab",
    description: "Mumbai to Narmada Parikrama one way cab service offers convenient drop travel for pilgrims without return charges. It is ideal for flexible spiritual journeys. Comfortable vehicles ensure smooth travel. It provides budget-friendly options."
  },
  {
    name: "Mumbai to Narmada Parikrama Round Trip Taxi",
    description: "Mumbai to Narmada Parikrama round trip taxi service offers complete travel solutions for onward and return pilgrimage journeys. It is ideal for organized spiritual tours. Professional drivers ensure timely service. It guarantees a stress-free experience."
  },
  {
    name: "Mumbai to Narmada Parikrama Innova Cab",
    description: "Mumbai to Narmada Parikrama Innova cab provides spacious and comfortable travel for families and groups on pilgrimage. It ensures smooth long-distance travel with ample seating. Ideal for group yatra journeys. It offers reliable transportation."
  },
  {
    name: "Mumbai to Narmada Parikrama Ertiga Cab",
    description: "Mumbai to Narmada Parikrama Ertiga cab offers economical and comfortable travel for small groups of pilgrims. It ensures good mileage and comfort for long routes. Suitable for family spiritual travel. It guarantees smooth journey experience."
  },
  {
    name: "Mumbai to Narmada Parikrama Sedan Cab",
    description: "Mumbai to Narmada Parikrama sedan cab provides affordable and comfortable travel for individuals or small families. It is ideal for budget-friendly pilgrimage journeys. Smooth and safe ride experience is ensured. It offers reliable service."
  },
  {
    name: "Mumbai to Narmada Parikrama SUV Taxi",
    description: "Mumbai to Narmada Parikrama SUV taxi offers spacious and premium travel for groups and families on pilgrimage. It ensures comfort, safety, and reliability for long-distance journeys. Ideal for rough and extended routes. It provides a premium travel experience."
  },
  {
    name: "Narmada Parikrama Tour Package from Mumbai",
    description: "Narmada Parikrama tour package from Mumbai offers complete pilgrimage travel solutions including cab, route planning, and stops. It is designed for a smooth spiritual journey experience. Ideal for devotees seeking organized travel. It ensures a hassle-free yatra."
  },
  {
    name: "Best Narmada Parikrama Cab Service Mumbai",
    description: "Best Narmada Parikrama cab service Mumbai provides top-rated vehicles, experienced drivers, and reliable pilgrimage travel solutions. It ensures safety, comfort, and devotion-focused journey. Multiple cab options are available. It guarantees a peaceful travel experience."
  }
],

tableData: [
  ["Mumbai to Narmada Parikrama Cab", "Narmada Parikrama Cab from Mumbai"],
  ["Mumbai to Narmada Yatra Taxi", "Mumbai to Narmada Parikrama Cab Service"],
  ["Cab from Mumbai for Narmada Parikrama", "Taxi from Mumbai for Narmada Yatra"],
  ["Mumbai to Narmada Parikrama Cab Booking", "Mumbai to Narmada Parikrama Taxi Booking Online"],
  ["Mumbai to Narmada Parikrama Cab Price", "Mumbai to Narmada Parikrama Taxi Fare"],
  ["Mumbai to Narmada Parikrama One Way Cab", "Mumbai to Narmada Parikrama Round Trip Taxi"],
  ["Mumbai to Narmada Parikrama Innova Cab", "Mumbai to Narmada Parikrama Ertiga Cab"],
  ["Mumbai to Narmada Parikrama Sedan Cab", "Mumbai to Narmada Parikrama SUV Taxi"],
  ["Narmada Parikrama Tour Package from Mumbai", "Best Narmada Parikrama Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Narmada Parikrama Travel Solution",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai to Narmada Parikrama cab service covering the full spiritual circuit with comfort and proper route guidance."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long religious routes like Narmada Parikrama, ensuring safe driving, correct route sequence, and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Packages",
    WhyChoosedescription: "We offer customizable 7 to 15 day Narmada Parikrama packages from Mumbai based on your travel plan and comfort."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, regularly serviced, and maintained to ensure a comfortable long-distance spiritual journey."
  },
  {
    WhyChooseheading: "24/7 Pickup & Travel Flexibility",
    WhyChoosedescription: "Our cab services are available 24/7, allowing flexible departure from Mumbai as per your yatra schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Groups",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for family and group pilgrimages."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Narmada Parikrama cab booking due to reliable service, experienced drivers, and organized travel planning."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Narmada Parikrama cab service?", answer: "Yes, Royal Route Cabs offers complete Narmada Parikrama cab tour packages from Mumbai." },
  { question: "How many days are required for Narmada Parikrama?", answer: "Usually 7 to 15 days are required depending on the route and stops included in the yatra." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for this trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the Parikrama route?", answer: "Yes, we provide fully customizable Narmada Parikrama travel plans based on your preferences." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is highly recommended due to the long duration of the trip." },
  { question: "Do drivers guide the route during Parikrama?", answer: "Yes, our experienced drivers help with route guidance and important stop locations during the yatra." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pravin Patel",
    feedback: "The Mumbai to Narmada Parikrama cab service with Royal Route Cabs was very well organized and comfortable. The long spiritual journey was smooth and safely managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback: "Excellent experience for our Narmada Parikrama trip from Mumbai. The cab was clean, the driver was cooperative, and the entire journey felt peaceful and hassle-free.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Narmada Parikrama Cab Booking",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-narmada-parikrama-cab.jpg", // replace if needed
  "description": "Book Mumbai to Narmada Parikrama cab with Royal Route Cabs for a safe and comfortable spiritual journey. Complete Narmada Yatra with sedan, SUV, Innova, and luxury cars. One-way and round-trip packages available with experienced drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-narmada-parikrama-cab-booking"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Narmada Parikrama Cab Booking | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Narmada Parikrama cab with Royal Route Cabs. Complete spiritual Narmada Yatra with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available service."
  />

  <meta
    name="keywords"
    content="mumbai to narmada parikrama cab, narmada parikrama cab from mumbai, mumbai to narmada yatra taxi, mumbai to narmada parikrama cab service, cab from mumbai for narmada parikrama, taxi from mumbai for narmada yatra, mumbai to narmada parikrama cab booking, mumbai to narmada parikrama taxi booking online, mumbai to narmada parikrama cab price, mumbai to narmada parikrama taxi fare, mumbai to narmada parikrama one way cab, mumbai to narmada parikrama round trip taxi, mumbai to narmada parikrama innova cab, mumbai to narmada parikrama ertiga cab, mumbai to narmada parikrama sedan cab, mumbai to narmada parikrama suv taxi, narmada parikrama tour package from mumbai, best narmada parikrama cab service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonarmadaparokramacab;